'use client'

import { Separator } from '@ui/web/components'
import cn from '@config/tailwind/cn'

import type { BillingType } from './util'
import { ScheduledSeatsNotice } from '../../lib/scheduled-seats-notice'
import { InvoiceHistory } from './invoice-history'
import { PlanHeader } from './plan-header'

export interface BillingPageProps {
  /** `school` bills an organization of teachers; `web` bills one family. */
  type: BillingType
  /** Navigates inside the host app — receives an app-relative path such as `/checkout/add-on`. */
  onNavigate: (path: string) => void
  className?: string
}

/**
 * Body of `/pengaturan/tagihan` — a header strip per seat pool, then invoice history. Shared verbatim
 * by the school and family apps; only the copy flavor and the checkout destinations differ.
 * The page chrome (back link, page title) stays with each app's route.
 */
export function BillingPage({ type, onNavigate, className }: BillingPageProps) {
  return (
    <div className={cn('srd:flex srd:w-full srd:flex-col srd:gap-y-8', className)}>
      {/* Above the pool strips, because seats bought for next term are absent from every number in
          them — a renewed school reads its own ledger as unchanged without this line. */}
      <ScheduledSeatsNotice />

      <PlanHeader type={type} onNavigate={onNavigate} />

      <Separator />

      <InvoiceHistory type={type} />
    </div>
  )
}
